<script>
import JourneyPlanner from "@/vue/components/JourneyPlanner.vue";
import Modal from "@/vue/components/Modal.vue";
export default {
    components: {
        JourneyPlanner,
        Modal
    }
}
</script>
